import React from 'react'
import { styled, Typography } from '@mui/material'
import PropTypes from 'prop-types'

const ColorBox = styled('div')(
  {
    borderRadius: '8px',
    backgroundColor: '#ECEFF4',
    padding: '26px'
  },
  (props) => ({
    // Variants based on props
    ...(props.secondary && {
      backgroundColor: '#fff',
      border: '4px solid #0015C4',
      borderRadius: 32
    }),
    ...(props.outlined && {
      backgroundColor: '#fff',
      border: '4px solid #ECEFF4'
    }),
    ...(props.white && {
      backgroundColor: '#FFFFFF'
    })
  })
)

const Circle = styled('div')({
  borderRadius: 32,
  backgroundColor: 'white',
  marginRight: 16,
  height: '50px',
  width: '50px',
  overflow: 'hidden',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  direction: 'column'
})

export function PictureWrapper(props) {
  const { style, image } = props
  return (
    <Circle style={style}>
      <img src={image} alt='profile-picture' width='auto' height='100%' />
    </Circle>
  )
}

export function ColorBoxHeader(props) {
  const { children, variant } = props

  return (
    <ColorBox
      style={{
        padding: 4,
        paddingLeft: 24
      }}
    >
      <Typography sx={{ padding: '10px' }} variant={variant}>
        {children}
      </Typography>
    </ColorBox>
  )
}

export function ColorBoxContent(props) {
  const { children, variant, style } = props

  return (
    <ColorBox variant={variant} style={style}>
      {children}
    </ColorBox>
  )
}

ColorBoxHeader.propTypes = {
  children: PropTypes.node.isRequired,
  variant: PropTypes.string
}

ColorBoxHeader.defaultProps = {
  variant: 'h4'
}

ColorBoxContent.propTypes = {
  children: PropTypes.node.isRequired,
  style: PropTypes.object,
  variant: PropTypes.string
}

PictureWrapper.propTypes = {
  style: PropTypes.object,
  image: PropTypes.string
}
